module.exports = __webpack_public_path__ + "img/monoxid-sensor-lg-bad.27ea162d.svg";